// @ts-strict-ignore
import { Injectable } from '@wikia/dependency-injection';

import { context, DomListener, Nativo, SlotCreatorConfig } from '@wikia/ad-engine';

import { SlotSetupDefinition } from '../utils/insert-slots';

@Injectable()
export class NativoSlotsDefinitionRepository {
	protected nativo: Nativo;

	constructor(protected domListener: DomListener) {
		this.nativo = new Nativo(context);
	}

	getNativoFeedAdConfig(slotCreatorConfig: SlotCreatorConfig | null = null): SlotSetupDefinition {
		if (!this.nativo.isEnabled()) {
			return;
		}

		return {
			slotCreatorConfig,
			activator: () => {
				this.nativo.scrollTriggerCallback(Nativo.FEED_AD_SLOT_NAME);
			},
		};
	}
}
